export default __webpack_public_path__ + "static/media/professional-scrum-master.01e482a1.png";